interface HistoryAccountShowProps {
  Title?: string;
  Amount?: number;
  Status?: string;
  CreateAt?: string;
  isReject?: boolean;
  DisplayCreatedAt?: string;
  Color: string;
}

export default function HistoryAccountShow(props: HistoryAccountShowProps) {
  return (
    <>
      <div>
        <div
          className="card-add"
          style={{
            paddingTop: 5,
            paddingBottom: 0,
          }}
        >
          <div className="font-card-add text-left">
            {props.DisplayCreatedAt}
          </div>
          <div className="font-card-add text-center">{props.Title}</div>
          <div className="font-card-add">
            <label
              style={{
                color: !props.isReject ? "#29c94d" : "red",
              }}
            >
              <div>{props.Status}</div>
            </label>
          </div>
          <div
            className="font-card-add text-right"
            style={{
              color: (props.Amount ?? 0) > 0 ? "#29c94d" : "red",
              fontWeight: "bold",
            }}
          >
            {props.Amount?.format(2, 0)}
            {(props.Amount ?? 0) > 0 ? "+" : "-"}
          </div>
        </div>
      </div>

      {/*  <div className="container margin-top-10">
        <div className="margin-left-10">
          <div className="row">
            <div className="col-2">
              <h4></h4>
            </div>
            <div className="col-10">
              <div style={{ color: props.Color }} className="text-right">
                <h4>{props.Amount?.format(2, 0)}</h4>
              </div>
            </div>
          </div>
        </div>
        <div className="">
          <div className="row">
            <div className="col-6"></div>
            <div className="col-6"></div>
            <div className="col-6"></div>
            <div className="col-6"></div>
            <div className="col-6"></div>
            <div className="col-6">
              <div className="text-right">{props.Status}</div>
            </div>
            <div className="col-12">
              <div className="text-right">{props.DisplayCreatedAt}</div>
            </div>
          </div>
        </div>
        <div style={{ paddingTop: 5 }}>
          <div className="bottom-line-yellow margin-bottom-10"></div>
        </div>
      </div> */}
    </>
  );
}
